/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateFolderModel,
  ICreateFolderRequest,
  IMappers,
  ICreateFolderResponse,
  ICreateFolderResponseError,
  TCreateFolderResponse,
} from './types';

const defaultConfig: TCreateFolderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/create-folder/',
  hostType: 'api',
} as TCreateFolderModel;

function createCreateFolderModel(parameters: ICreateFolderRequest): TCreateFolderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateFolderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateFolderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateFolder<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateFolderOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCreateFolderResponse> {
  const { response, statusCode } = await httpApi.fetch(createCreateFolderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateFolderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateFolderResponseError);
    }
  }

  return { response, statusCode } as TCreateFolderResponse;
}

export { defaultConfig, createCreateFolderModel, fetchCreateFolder };
